import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Function for login
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // useNavigate is a React Router hook that allows navigation to different pages
  const navigate = useNavigate();

  // Defines an asynchronous function to handle login when the form is submitted
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://jerinmjohn.pythonanywhere.com/api/login/", {
        username,
        password,
      });
      
      console.log("API Response:", response);

      localStorage.setItem("token", response.data.data.token);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login Error:", error); 
      alert("Invalid login credentials");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card p-4 shadow">
            <h2 className="text-center">Login</h2>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div>
                <button type="submit" className="btn btn-primary w-100">
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
